export const DataUtils = {
  objectToFormData(obj) {
    const data = new FormData();

    for (const key of Object.keys(obj)) {
      data.append(key, obj[key]);
    }

    return data;
  },

  getImageSize(file) {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.src = window.URL.createObjectURL(file);
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
    });
  },

  isImage(file) {
    return file && file['type'].split('/')[0] === 'image';
  },

  encodeImageToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result
          .replace('data:', '')
          .replace(/^.+,/, '');

        resolve(base64String);
      };
      reader.readAsDataURL(file);
    });
  },

  dataURItoBlob(dataURI) {
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: 'image/png' });
  },
};
